import { render, staticRenderFns } from "./ReportCommSupport.vue?vue&type=template&id=6a807df6&scoped=true&"
import script from "./ReportCommSupport.vue?vue&type=script&lang=js&"
export * from "./ReportCommSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a807df6",
  null
  
)

export default component.exports